import * as React from 'react';
import { cn } from '../../lib/utils';

interface FormFieldProps {
  label?: string;
  description?: string;
  error?: string;
  children: React.ReactNode;
  className?: string;
}

function FormField({
  label,
  description,
  error,
  children,
  className,
}: FormFieldProps) {
  return (
    <div className={cn('space-y-1.5', className)}>
      {label && (
        <label className="text-sm font-semibold text-foreground pl-1">
          {label}
        </label>
      )}
      {children}
      {description && !error && (
        <p className="text-xs text-muted-foreground pl-1">{description}</p>
      )}
      {error && <p className="text-xs text-destructive pl-1">{error}</p>}
    </div>
  );
}

export { FormField };
export type { FormFieldProps };
